import React from "react";
import {
  Box,
} from '@mui/material';

import LogoHeader from "../../../Shared/LogoHeader/LogoHeader";
import Stepper from "./components/Stepper";

const TutorialSteps = () => {
  return (
    <Box
      component="div"
      className="inspection"
    >
      <LogoHeader />
      <div className="title" data-testid='tutorial-header'>Faça vistorias offline</div>
      <div className="description">
        Instale o aplicativo no seu <br />navegador e utilize mesmo sem <br />conexão
      </div>
      <Stepper />
    </Box>
  );
}

export default TutorialSteps;
